import React from 'react';
import { ChevronLeft, Search } from 'lucide-react';

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="page-head">
      <div>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions}
    </div>
  );
}

export function ListToolbar({ search, onSearch, placeholder, filters }) {
  return (
    <div className="toolbar-row">
      <div className="field-search">
        <Search size={14} />
        <input
          value={search}
          onChange={(event) => onSearch(event.target.value)}
          placeholder={placeholder}
        />
      </div>
      {filters}
    </div>
  );
}

export function DetailShell({
  backLabel,
  onBack,
  marker,
  title,
  subtitle,
  meta,
  actions,
  filters,
  stats,
  left,
  right,
}) {
  return (
    <div>
      <button className="secondary detail-back" onClick={onBack}>
        <ChevronLeft size={14} /> {backLabel}
      </button>
      <div className="detail-head">
        {marker}
        <div className="detail-head-title">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {meta}
        {actions && <div className="detail-head-actions">{actions}</div>}
      </div>
      {filters}
      {stats}
      <div className="detail-layout">
        <div className="detail-main">{left}</div>
        <aside className="detail-side">{right}</aside>
      </div>
    </div>
  );
}

// The few read-only facts that used to need a side panel, sat next to the
// title instead: one line per fact, dropped from the strip when empty.
export function DetailMeta({ items }) {
  const visible = items.filter((item) => item.value);
  if (!visible.length) return null;
  return (
    <div className="detail-meta">
      {visible.map((item) => (
        <div key={item.label}>
          <span className="detail-meta-label">{item.label}</span>
          <span className="detail-meta-value">{item.value}</span>
        </div>
      ))}
    </div>
  );
}

export function InfoPanel({
  title,
  editing,
  rows,
  onEdit,
  onCancel,
  onSave,
  actions,
}) {
  return (
    <section className="card info-panel">
      <h2>{title}</h2>
      <dl className="meta editable-meta">
        {rows.map((row) => (
          <React.Fragment key={row.label}>
            <dt>{row.label}</dt>
            <dd>{editing ? row.edit : row.value}</dd>
          </React.Fragment>
        ))}
      </dl>
      <div className="info-actions">
        {editing ? (
          <>
            <button className="secondary" onClick={onCancel}>
              Cancel
            </button>
            <button className="primary" onClick={onSave}>
              Save
            </button>
          </>
        ) : (
          <>
            {actions}
            {/* No onEdit = a read-only panel (e.g. a team manager looking at
                one of their people), so the button is left out entirely. */}
            {onEdit && (
              <button className="secondary" onClick={onEdit}>
                Edit
              </button>
            )}
          </>
        )}
      </div>
    </section>
  );
}
